import SpotTpsl from './index';

export default { path: '/home/orderLimit/spotTpsl', component: SpotTpsl };
